"use strict";
/**
 * 安全 decode
 *
 * ### Example
 * ```
 * const value = decode('C%9E5%H__a100373__b4');
 * ```
 */
Object.defineProperty(exports, "__esModule", { value: true });
function decode(value) {
    try {
        return decodeURIComponent(value);
    }
    catch (e) {
        return void 0;
    }
}
exports.decode = decode;
